import { render, staticRenderFns } from "./Sustainability.vue?vue&type=template&id=66ae47ba&scoped=true"
import script from "./Sustainability.vue?vue&type=script&lang=js"
export * from "./Sustainability.vue?vue&type=script&lang=js"
import style0 from "./Sustainability.vue?vue&type=style&index=0&id=66ae47ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ae47ba",
  null
  
)

export default component.exports